import appStationsHeatmap from "../../views/appRoutes/stationsHeatmap.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "stationsheatmap";
  const params = ["type"];

  $stateProvider.state("stationsheatmap", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appStationsHeatmap,
      },
    },
    reloadOnSearch: false,
    data: { title: "Stations Heatmap" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/stationsHeatmap/stationsHeatmap.urls.js